export enum CartAnalyticsEnum {
  OPEN_CART = '[PAC WEB] Carrinho - Abriu carrinho',
  ADD_MORE_PROCEDURES = '[PAC WEB] Carrinho - Adicionou mais consultas ou exames',
  CONFIRM_PHONE = '[PAC WEB] Carrinho - Confirmou telefone',
  UPDATE_PHONE = '[PAC WEB] Carrinho - Atualizou telefone',

  VIEW_CART_CLEAR_CONFIRMATION = '[PAC WEB] Carrinho - Exibiu confirmação de esvaziar carrinho',
  CONFIRM_CART_CLEAR = '[PAC WEB] Carrinho - Confirmou esvaziar carrinho',
  CANCEL_CART_CLEAR = '[PAC WEB] Carrinho - Manteve o carrinho',
}

export enum CartClearMotive {
  ADDING_STANDALONE = 'guia_avulsa_entrando',
  CART_HAS_STANDALONE = 'carrinho_com_guia_avulsa',
}

export enum CartOrigin {
  SEARCH_RESULTS = 'resultado_busca',
  PROFILE = 'perfil',
  HOME = 'home',
  APPOINTMENTS = 'agendamentos',
  OTHER = 'outro',
}

export enum AddMoreProceduresDestination {
  CLOSED_MODAL = 'fechou_modal',
  SEARCH = 'busca',
}
